import React from 'react';
import './About.css';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const About = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="about" id="about">
      <div className="about-title">
        <div className="about-tag">
          <span className="about-tag-text">{t.aboutTag}</span>
        </div>
        <h2 className="about-heading animated-gradient-text">{t.aboutTitle}</h2>
        <p className="about-description">
          {t.aboutDescription}
        </p>
      </div>
      
      <div className="about-cards">
        <div className="about-card">
          <div className="about-card-container">
            <div className="about-card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="about-card-text">
              <h3 className="about-card-title">{t.aboutEducation}</h3>
              <p className="about-card-description">
                {t.aboutEducationText}
              </p>
            </div>
          </div>
        </div>

        <div className="about-card">
          <div className="about-card-container">
            <div className="about-card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="about-card-text">
              <h3 className="about-card-title">{t.aboutConsulting}</h3>
              <p className="about-card-description">
                {t.aboutConsultingText}
              </p>
            </div>
          </div>
        </div>

        <div className="about-card">
          <div className="about-card-container">
            <div className="about-card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 3V21H21" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M7 16L12 11L16 15L21 10" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M21 10H16V15" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="about-card-text">
              <h3 className="about-card-title">{t.aboutCorporate}</h3>
              <p className="about-card-description">
                {t.aboutCorporateText}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
